<template>
<div class="chapter">
<div class="inner_page">
<p class="C155"><a id="page_ix"><img alt="" class="Image105" src="img/10_1.png" width="71%"/></a></p><a id="page_ix">
<p class="C114_13"><em>Author, August 1955</em>.</p>
<p class="C155"><img alt="" class="Image103" src="img/10_2.png"/></p>
<p class="C114_13"><em>Author</em>, far right, <em>discussing</em> Al Yawm<em>’s political line in Baqa al-Gharbiyya, 1963</em>.</p>
</a><p class="C155"><a id="page_ix"></a><a id="page_x"><img alt="" class="Image103" src="img/11_1.png"/></a></p><a id="page_x">
<p class="C114_13"><em>Author</em>, second from left, <em>with Jacqueline Kahanoff</em>, second from right, <em>and hosts in Acre, 1964</em>.</p>
<p class="C155"><img alt="" class="Image103" src="img/11_2.png"/></p>
<p class="C114_13"><em>Author with wife, Rachel, and their three sons</em>: left to right, <em>Rony, Amir, and Elan, 1965</em>.</p>
</a><p class="C155"><a id="page_x"></a><a id="page_xi"><img alt="" class="Image103" src="img/12_1.png"/></a></p><a id="page_xi">
<p class="C114_13"><em>Author</em>, third from right, <em>with reporters and hosts in Taiba, 1965</em>.</p>
<p class="C155"><img alt="" class="Image103" src="img/12_2.png"/></p>
<p class="C114_6">Left to right: <em>Elan, Amir, and Rony, 1966</em>.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Image.vue?943d74f2